import { collection, getDocs, query, where } from 'firebase/firestore';
import { db } from '../config/firebase';
import { QuickButtonTemplate } from '../types/purchase';

const COLLECTION_NAME = 'quickButtons';

const normalizeQuickButton = (raw: any): QuickButtonTemplate => ({
  id: raw.id,
  code: raw.code || '',
  category: raw.category || '',
  itemName: raw.itemName || raw.name || '',
  description: raw.description || '',
  unit: raw.unit || '',
  unitPrice: Number(raw.unitPrice || 0),
  storeLocationId: raw.storeLocationId || '',
  isActive: raw.isActive !== false,
});

export const quickButtonService = {
  async getAllQuickButtons(): Promise<QuickButtonTemplate[]> {
    const q = query(collection(db, COLLECTION_NAME), where('isActive', '!=', false));
    const snapshot = await getDocs(q);
    return snapshot.docs.map((item) => normalizeQuickButton({ id: item.id, ...item.data() }));
  },
};
